import {
  dimensiondata_1_orszag_group_dimension_1_2_3_row_expanded,
  dimensiondata_2_termekek_group_1_2_3_column,
  dimensiondata_2_termekek_group_column,
  dimensiondata_3_dimension_1_import_filter,
  kilo_tonna_value_1_data_precision,
  year_column,
  order_1,
  order_2
} from '../../fields';
import { PivotGridConfig } from '../../utils/pivot-grid-config';

export const evesOlajKulkerConfig: PivotGridConfig = {
  showChart: false,
  treeHeaderLayout: false,
  filterYear: {numberOfYears: 4},
  options: {
    store: {
      version: 4,
      type: 'odata',
      url: 'odata/v4/public/EvesOlajKulker',
      select: ['date', 'dimension_1', 'dimension_2', 'dimension_3', 'value_1'],
      beforeSend: (e: any) => {
        e.headers = {
          Accept: 'application/json;odata.metadata=none',
        };
      },
    },
    retrieveFields: false,
    fields: [
      ...dimensiondata_1_orszag_group_dimension_1_2_3_row_expanded,
      year_column,
      ...dimensiondata_2_termekek_group_1_2_3_column,
      ...dimensiondata_3_dimension_1_import_filter,
      kilo_tonna_value_1_data_precision,
      order_1,
      order_2
    ],
  },
};
